import { inject, Pipe, PipeTransform } from '@angular/core';
import { PermissionService } from '@services/permission.service';
import { RolesDTO } from '@api';

@Pipe({
  name: 'artHasRole',
})
export class HasRolePipe implements PipeTransform {
  permissionService = inject(PermissionService);

  transform(role: RolesDTO): boolean {
    return this.permissionService.hasRole(role as RolesDTO);
  }
}
